import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@glu/theming';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import Modal from '@glu/modal-react';
import classnames from 'classnames';
import Button from 'common/Button';
import uiActions from 'core/ui/actions';
import fieldActions from 'core/fields/actions';
import isMobileDevice from 'utils/isMobileDevice';
import dataActions from 'core/data/actions';

const styles = () => ({
  confirmationText: {
    marginTop: '10px',
  },
  mobileModal: {
    dialog: {
      content: {},
    },
    position: 'fixed',
    zIndex: '5',
  },
  spinner: {
    '& > .spinner': {
      position: 'relative !important',
    },
    display: 'block',
    margin: [0, 'auto'],
    position: 'relative',
    textAlign: 'center',
  },
});

const RetrySocureFlow = ({ classes, ...props }) => {
  const { fieldDescr, hidden = true, options } = useSelector(
    ({ fields }) => fields[props.name],
    shallowEqual,
  );

  const {
    ui: { isModalOpen = false },
  } = useSelector((state) => state, shallowEqual);

  // useDispatch
  const dispatch = useDispatch();

  const setVerificationType = (value) => () => {
    dispatch(dataActions.changeData(props.name, value));
    dispatch(fieldActions.reRender(props.name));
  };

  useEffect(() => {
    // if (!hidden && isMobileDevice()) {
    if (!hidden) {
      dispatch(uiActions.setModalOpen(true));
    } else {
      dispatch(uiActions.setModalOpen(false));
    }
  }, [dispatch, hidden]);

  return (
    <Modal suppressIcon show={isModalOpen} hideBackdrop className={classes.mobileModal}>
      <div className={classes.confirmationText}>{fieldDescr}</div>
      <div className={classes.confirmationButtons}>
        {options?.map((button) => (
          <Button
            key={button.type}
            type="button"
            className={classnames(' btn btn-mobile')}
            variant="tertiary"
            onClick={setVerificationType(button.type)}
          >
            {button.label}
          </Button>
        ))}
      </div>
    </Modal>
  );
};

RetrySocureFlow.propTypes = {
  name: PropTypes.string.isRequired,
};

export default withStyles(styles)(RetrySocureFlow);
